import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Fab, Grid, Dialog } from '@material-ui/core'
import { connect } from 'react-redux'
import { ReduxStore } from '../../../stores';
import MuiTheme from '../../../MuiTheme';
import Form from '../../../Models/Chapters/Form';
import { OChapter } from '../../../Models/Chapters/Model';
import { Chapter } from '../../../Models/Chapters/@types';
import SimpleCard from '../../../Components/SimpleCard';
import { withRouter, RouteComponentProps } from 'react-router';
import DetailCard from '../../../Models/Chapters/DetailCard';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import { AxiosPromise } from 'axios';
import CircularLoader from '../../../Components/Loader/CircularLoader';
import { TDispatch } from '../../../Resources/GarbageUtils';

interface IStateProps {
    mainList?: Array<Chapter>
}

interface IDispatchProps {
    getChapters: (params?: any) => AxiosPromise
    deleteChapter: (chapterId: string) => AxiosPromise
    togglePublish: (chapter: Chapter) => AxiosPromise
}

interface OwnProps { }

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps, RouteComponentProps<{ bookId: string }>, OwnProps { }

interface IState {
    showForm: boolean
    selectedChapter?: Chapter
    chapterToEdit?: Chapter
    showConfrimationDialog: boolean
    chapterToDelete?: Chapter
    loading: boolean
}

class Chapters extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            showForm: false,
            showConfrimationDialog: false,
            loading: true
        }
    }

    togglePublishHandler = (chapter: Chapter) => this.props.togglePublish(chapter);

    OptionsConfig = [
        { icon: 'lock', label: 'Publish', handler: this.togglePublishHandler },
        { icon: 'edit', label: 'Edit', handler: (chapter: Chapter) => this.setState({ chapterToEdit: chapter, showForm: true }) },
        { icon: 'delete', label: 'Delete', handler: (chapter: Chapter) => this.setState({ chapterToDelete: chapter, showConfrimationDialog: true }) },
        { icon: 'details', label: 'View Details', handler: (chapter: Chapter) => this.setState({ selectedChapter: chapter }) }
    ]

    async componentDidMount() {
        await this.setState({ loading: true });
        await this.props.getChapters({ filter: { where: { bookId: this.props.match.params['bookId'] } } }).catch(error => { console.log('Error getting chapters data', error.response.data) });
        await this.setState({ loading: false });
    }

    handleDeleteBook = () => {
        if (this.state.chapterToDelete) {
            this.props.deleteChapter(this.state.chapterToDelete.id);
            this.setState({ showConfrimationDialog: false })
        }
    }

    render() {
        const { classes, mainList = [], location } = this.props;
        const { selectedChapter, chapterToEdit, loading } = this.state;
        return (
            <>
                {
                    this.state.showForm ? null :
                        <div className={classes.root} >
                            {
                                loading
                                    ?
                                    <CircularLoader />
                                    :
                                    <Grid container spacing={5} className={classes.listContainer} >
                                        {
                                            mainList.sort((a, b) => a.number - b.number).map((chapter, index) => {
                                                return (
                                                    <Grid item sm={4} key={index}>
                                                        <SimpleCard
                                                            entity={chapter}
                                                            title={`${chapter.number}. ${chapter.name}`}
                                                            link={`${location.pathname}/${chapter.id}/sections`}
                                                            optionsConfig={this.OptionsConfig}
                                                        />
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                            }
                            <Fab
                                color="secondary"
                                className={classes.addButton}
                                onClick={e => this.setState({ showForm: true })}
                            >
                                <i className='material-icons' >add</i>
                            </Fab>
                            {
                                selectedChapter
                                    ?
                                    <Dialog open={Boolean(selectedChapter)} >
                                        <DetailCard chapter={selectedChapter} onClose={() => this.setState({ selectedChapter: undefined })} />
                                    </Dialog>
                                    :
                                    null
                            }
                            <ConfirmationDialog
                                openState={this.state.showConfrimationDialog}
                                onAgree={this.handleDeleteBook}
                                onClose={() => this.setState({ showConfrimationDialog: false })}
                                title={this.state.chapterToDelete ? this.state.chapterToDelete.name : 'This chapter'}
                                message={`Are you sure to delete ${this.state.chapterToDelete ? this.state.chapterToDelete.name : 'this book'}`}
                            />
                        </div>
                }
                {this.state.showForm ? <Form chapter={chapterToEdit} open={this.state.showForm} onClose={() => this.setState({ showForm: false, chapterToEdit: undefined })} /> : null}
            </>
        )
    }
}

const mapStateToProps = (state: ReduxStore): IStateProps => ({
    mainList: state.Chapters.mainList
})

const mapDispatchToProps = (dispatch: TDispatch): IDispatchProps => ({
    getChapters: (params?: any) => dispatch(OChapter.getItemsList(params)),
    deleteChapter: (chapterId: string) => dispatch(OChapter.deleteItem(chapterId, {}, undefined, { deletedItemId: chapterId })),
    togglePublish: (chapter) => dispatch(OChapter.postActivity(OChapter.Activities.TOGGLE_PUBLISH, {}, { id: chapter.id, publish: !chapter.isPublished }))
})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 25
    },
    addButton: {
        position: 'fixed',
        right: '24px', bottom: '24px'
    },
    listContainer: {
        width: '85%',
        marginTop: 36
    }
})

export default withRouter(connect<IStateProps, IDispatchProps, OwnProps, ReduxStore>(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(Chapters)))